
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.972 13.906l-8.028 7.912a1.503 1.503 0 01-2.11 0 1.477 1.477 0 01-.015-2.088l8.031-7.916 2.123-2.1 2.13 2.092 8.048 7.94a1.48 1.48 0 01.015 2.093 1.51 1.51 0 01-2.13.015l-8.064-7.948z","fill":"#000","fill-rule":"nonzero"}})])
          )
        }
      }
    